import { Link, NavLink } from "react-router-dom";
import Logo from "./Logo";
import UserMenu from "./UserMenu";
import { useAuth, hasRole } from "../context/AuthContext";

/**
 * Workbench shell with authenticated user menu.
 */
export default function Layout({ children }) {
  const { user } = useAuth();
  const linkBase = "h-8 inline-flex items-center px-3 rounded-md text-[13px] font-medium transition-colors";
  const linkStyle = ({ isActive }) => ({
    color: isActive ? "var(--text-primary)" : "var(--text-muted)",
    background: isActive ? "var(--bg-subtle)" : "transparent",
  });
  return (
    <div className="min-h-screen" style={{ background: "var(--bg-app)" }} data-testid="app-shell">
      <header
        className="sticky top-0 z-50 bg-white"
        style={{ borderBottom: "1px solid var(--border-subtle)" }}
        data-testid="app-header"
      >
        <div className="max-w-[1600px] mx-auto px-6 h-14 flex items-center gap-6">
          <Link
            to="/"
            className="flex items-center gap-2.5 group"
            data-testid="app-logo"
          >
            <Logo size={28} />
            <div className="leading-tight flex items-baseline gap-2">
              <span
                className="font-semibold tracking-tight text-[15px]"
                style={{ color: "var(--text-primary)" }}
              >
                TechQuote
              </span>
              <span
                className="text-[13px] font-normal hidden lg:inline"
                style={{ color: "var(--text-muted)" }}
              >
                Decoder offerte
              </span>
            </div>
          </Link>
          {user && (
            <nav className="flex items-center gap-1" data-testid="app-nav">
              <NavLink to="/" end className={linkBase} style={linkStyle} data-testid="nav-offerte">
                Offerte
              </NavLink>
              <NavLink to="/workbench" className={linkBase} style={linkStyle} data-testid="nav-workbench">
                Scrivania
              </NavLink>
              {hasRole(user, "titolare", "super_admin") && (
                <NavLink
                  to="/reports/log-offerte"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-reports"
                >
                  Report
                </NavLink>
              )}
              {hasRole(user, "super_admin") && (
                <NavLink
                  to="/admin/templates"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-templates"
                >
                  Template
                </NavLink>
              )}
              {hasRole(user, "titolare", "super_admin") && (
                <NavLink
                  to="/insegna"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-insegna"
                >
                  Insegna
                </NavLink>
              )}
              {hasRole(user, "super_admin") && (
                <NavLink
                  to="/admin"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-admin"
                >
                  Listino
                </NavLink>
              )}
              {hasRole(user, "super_admin") && (
                <NavLink
                  to="/admin/audit"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-audit"
                >
                  Audit
                </NavLink>
              )}
              {hasRole(user, "super_admin") && (
                <NavLink
                  to="/admin/errors"
                  className={linkBase}
                  style={linkStyle}
                  data-testid="nav-errors"
                >
                  Errori
                </NavLink>
              )}
            </nav>
          )}
          <div className="ml-auto">
            <UserMenu />
          </div>
        </div>
      </header>
      <main>{children}</main>
    </div>
  );
}
